import React, { useEffect, useState } from "react";
import { useAuth } from "../AuthContext";
import {createUser, deleteUser, getUsers} from "../api/userapi";
import { useNavigate } from "react-router-dom";
import DataTable from "../components/DataTable";
import {deleteOffer} from "../api/offerapi";


export default function Users() {
    const { token } = useAuth();
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const fetchUsers = async (silent = false) => {
        setLoading(!silent);
        try {
            const res = await getUsers();
            if (res?.success) {
                console.log(res.data)
                setUsers(res.data);
                setError(null);
            } else {
                setError(res?.message || "Failed to fetch users");
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, [token]);

    const handleAdd = async() => {
        const tempUser = {
            UserID: "temp-" + Date.now(),
            Name: "Creating new user...",

        };


        setUsers((prev)=>[tempUser, ...prev]);

        setLoading(true);
        try {
            await createUser()
            await fetchUsers(true); // silent refresh (no flash)
        } catch {
            // if failed, remove the temp one
            setUsers((prev)=>prev.filter((item)=>item.UserID === tempUser.UserID))
        } finally {
            setLoading(false);
        }
    };

    const handleRemove = async(user) => {
        const prev = users
        setUsers(prev.filter((item)=>item.UserID === user.UserID))

        setLoading(true);
        try {
            await deleteUser(user.UserID);
            await fetchUsers(true); // silent refresh
        } catch {
            // rollback if failed
            setUsers(prev);
        } finally {
            setLoading(false);
        }
    };


    const handleRowClick = (user) => {
        navigate(`/users/${user.UserID}`);
    };

    if (loading) return <p className="m-3">Loading users...</p>;
    if (error) return <p className="m-3 text-danger">❌ {error}</p>;

    return (
        <div className="container mt-4">
            <DataTable
                title="Users"
                columns={[
                    { key: "Name", label: "Name", searchable: true },
                    { key: "Phone", label: "Phone", searchable: true },
                    { key: "Title", label: "Role", filterable: true },
                    {key: "Locations", label: "Employment", filterable: true},
                    {key: "Cards", label:"Cards", filterable: true}
                ]}
                data={users.map((u) => ({
                    ...u,
                    Title: u.Title || "—",
                }))}
                add
                remove
                onAdd={handleAdd}
                onRemove={handleRemove}
                onRowClick={handleRowClick}
            />
        </div>
    );
}
